import style from "./FullPageLoader.module.css";

function FullPageLoader() {
	return (
		<div className={style.page}>
			<div className={style.header}>
				<span className={style.loader}></span>
			</div>
			<div className={style.body}>
				<span className={style.loader}></span>
				<span className={style.loaderMobile}></span>
			</div>
		</div>
	);
}

export default FullPageLoader;
